import { render, staticRenderFns } from "./aPricingStrategyRecommendationTooltip.vue?vue&type=template&id=68fda06a&scoped=true"
import script from "./aPricingStrategyRecommendationTooltip.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyRecommendationTooltip.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyRecommendationTooltip.vue?vue&type=style&index=0&id=68fda06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fda06a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
